<style>
.price-inside-prod .content-box {
  padding: 0px !important;
  margin: 0px !important;
}

.price-inside-prod .todo-content {
  padding: 0px !important;
  margin: 0px !important;
}

.price-inside-prod .all-tasks-w {
  padding-top: 0px !important;
  margin-top: 0px !important;
}
</style>
<template>
  <div class="todo-app-w" :class="{ 'price-inside-prod': sku_p != null }">
    <div class="col-12 content-box">
      <div>
        <div>
          <router-link :to="{
            name: 'cat-productos-editar',
            params: { sku: current.sku },
          }">
            <a style="color: #0264b5 ;">
              <i class="fas fa-angle-double-left"></i> Regresar a Producto
            </a>
          </router-link>
        </div>
      </div>
      <br>
      <div class="row">
        <div class="col-sm-12">
          <div class="element-wrapper">
            <div class="todo-content">
              <div class="btn-group dropleft" style="float: right;">
                <button type="button" class="btn btn-secondary dropdown-toggle" data-toggle="dropdown"
                  aria-haspopup="true" aria-expanded="false">
                  Más Opciones &nbsp;<i class="fas fa-chart-bar"></i>
                </button>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                  <router-link class="dropdown-item" :to="{
                    name: 'cat-productos-precios-v2',
                    params: {},
                  }">
                    <i class="fas fa-cash-register"></i>&nbsp;
                    <span>Ver Análisis de Precios</span>
                  </router-link>
                  <router-link class="dropdown-item" :to="{
                    name: 'compras-lista-precios-compras',
                    params: {},
                  }">
                    <i class="fa fa-dollar-sign"></i>&nbsp;
                    <span>Ver Precios de Compras</span>
                  </router-link>
                </div>
              </div>
              <h4 class="todo-content-header">
                <i style="color: white; font-size: 20px;" class="fas fa-certificate"></i>
                <span style="color: black;">Precios de Producto por Lista
                  <br>
                  {{ current.sku }} - {{ current.nombre }}</span>
              </h4>
              <div class="col-12" style="float: right;">
                <h5 class="todo-content-header">
                  <i class="fas fa-times" style="color: white;"></i><span>Costo Global Unitario
                    Q {{ redondearDosDecimales(current.ultimo_costo) }}</span>
                </h5>
              </div>
              <div class="all-tasks-w">
                <div class="col-12 row">
                  <div class="status-pill col-1"
                    style="height: 17px; text-align: center; background-color: #4e9322; color: white;">
                    <span>Activos</span>&nbsp;
                  </div>
                  &nbsp;&nbsp;
                  <div class="status-pill red col-1" style="height: 17px; text-align: center; color: white;">
                    <span>Inactivos</span>
                  </div>
                  &nbsp;&nbsp;
                  <div class="status-pill col-1"
                    style="height: 17px; text-align: center; color: white; background-color: #0264b5;"
                    title="Temporada o Campaña">
                    <span>Especiales</span>
                  </div>
                </div>
                <div style="float: right;">
                  <div class="row">
                    <div>
                      <label style="color: gray;">Mostrar Inactivos</label> &nbsp;
                      <label class="switch">
                        <input class="text-center" type="checkbox" v-model="switchState" true-value="1" false-value="0"
                          id="switchInactivos" @change="showInactiveItems()" />
                        <span class="slider-button"></span>
                      </label>
                    </div>
                    &nbsp;&nbsp;
                  </div>
                </div>
                <br><br>                
                <!--START TASKS HEADER-->
                <div class="tasks-header-w" style="background-color: #e9f3f7; border-radius: 10px;" v-if="campanasVigentes.length>0">
                  <a type="button" class="tasks-header-toggler" @click="toggleSection2($event,'campanas')"
                    style="color: black;" title="Toggle Lista">
                    <i :class="isSectionExpanded2('campanas') ? 'os-icon os-icon-arrow-up4': 'os-icon os-icon-arrow-down4'"
                      style="color: #9aa2a6;"></i>
                  </a>
                  &nbsp;&nbsp;&nbsp;
                  <div v-if="campanasVigentes.length==0">
                    <h5 class="tasks-header" >
                      El producto no participa en ninguna campaña/oferta
                    </h5>
                  </div>  
                  <div v-if="campanasVigentes.length>0">                    
                      &nbsp;
                      <span class="badge" style="background-color:#0264b5"><h5  style="color:white">Campañas</h5></span>                      
                  <br><br>  
                  </div>
                </div>  
                <!--END - TASK HEADER -->

                <!-- INICIO DE TABLA DE LISTA DE PRECIOS-->
                <div class="tasks-list-w" v-show="isSectionExpanded2('campanas')" v-if="campanasVigentes.length>0">
                  <div class="table-responsive">
                    <table class="table table-lightborder">
                      <thead>
                        <th>Nombre de Campaña</th>
                        <th>Unidad de Medida</th>      
                        <th>Fecha Inicio</th>
                        <th>Fecha Fin</th>                               
                        <th>Precio Oferta</th>                                         
                      </thead>
                      <tbody>
                        <tr v-for="elem in campanasVigentes" :key="elem.id">
                          <td>{{ elem.nombre_campana }}</td>
                          <td>{{ elem.unidad_medida }}</td>
                          <td>{{ elem.fecha_inicio }}</td>                    
                          <td>{{ elem.fecha_fin }}</td>                          
                          <td>Q.{{ elem.precio }}</td>                                       
                        </tr>                 
                      </tbody>
                    </table>
                 </div> 
                </div> 
                &nbsp;&nbsp;
                <div class="tasks-section" v-for="l_precio in listas_de_precios" :key="l_precio.pk"
                  v-if="l_precio.id !== 5 && l_precio.id !== 13 && l_precio.estatus == true">
                  <!--START - TASKS HEADER-->
                  <div class="tasks-header-w" style="background-color: #e9f3f7; border-radius: 10px;"
                    v-if="getListaPrecio(l_precio, true).length > 0 || (switchState == 1 && getListaPrecio(l_precio, false).length > 0)">
                    <a type="button" class="tasks-header-toggler" @click="toggleSection($event, l_precio)"
                      style="color: black;" title="Toggle Lista">
                      <i :class="isSectionExpanded(l_precio) ? 'os-icon os-icon-arrow-down4' : 'os-icon os-icon-arrow-up4'"
                        style="color: #9aa2a6;"></i>
                    </a>
                    &nbsp;&nbsp;&nbsp;
                    <h5 class="tasks-header">{{ l_precio.nombre }} </h5>
                    <br><br>
                    <span class="tasks-sub-header"
                      style="background-color: lightgray; border-radius: 3px; height: 18px; width: 90px; text-align: center;"
                      v-if="l_precio.estatus">Lista Activa</span>
                    <span class="tasks-sub-header" v-if="!l_precio.estatus"
                      style="background-color: lightgray; border-radius: 3px; height: 18px; width: 110px; text-align: center;">Lista
                      Inactiva</span>
                    <a class="add-task-btn-dark" data-target="#modalAddProductoPrecio" data-toggle="modal" href="#"
                      @click="showModal(l_precio)" style="color:black; float: right;">
                      <i class="os-icon os-icon-ui-22"></i>
                      &nbsp;
                      <span>Agregar Precio</span>
                      &nbsp;&nbsp;&nbsp;
                    </a> 
                  </div>
                  <!--END - TASKS HEADER-->
                  <div class="tasks-list-w">
                    <!-- INICIO DE TABLA DE LISTA DE PRECIOS -->
                    <div class="table-responsive">
                      <table class="table table-lightborder">
                        <thead
                          v-if="getListaPrecio(l_precio, true).length > 0 || (switchState == 1 && getListaPrecio(l_precio, false).length > 0)">
                          <tr>
                            <th>Unidad Medida</th>
                            <th class="text-center">Fecha Inicio</th>
                            <th class="text-center">Fecha Fin</th>
                            <th class="text-right">Costo</th>
                            <th class="text-right">Otros</th>
                            <th class="text-center">Tipo Calculo</th>
                            <th class="text-center">Margen</th>
                            <th class="text-right">Precio</th>
                            <th class="text-right" style="width: 10px"></th>
                            <th class="text-right" style="width: 100px"></th>
                          </tr>
                        </thead>
                        <tbody>
                          <!-- INICIO DETALLE POR UNIDAD DE MEDIDA ACTIVOS -->
                          <tr v-for="precio in getListaPrecio(l_precio, true)" :key="precio.id" v-if="precio.estatus">
                            <td class="nowrap">
                              {{ precio.unidad_medida.nombre }}
                            </td>
                            <td class="text-center">
                              {{ precio.valido_desde }}
                            </td>
                            <td class="text-center">
                              {{ precio.valido_hasta }}
                            </td>
                            <td class="text-right">{{ precio.costo }}</td>
                            <td class="text-right">
                              {{ precio.otros_costos }}
                            </td>
                            <td class="text-center">
                              {{ precio.tipo_calculo }}
                            </td>
                            <td class="text-center">
                              <span v-if="precio.tipo_calculo == 'FIJO'">Q</span>
                              {{ precio.margen }}
                              <span v-if="precio.tipo_calculo == 'PORC'">%</span>
                            </td>
                            <td class="text-right">{{ precio.precio }}</td>
                            <td class="text-right">
                              <div v-if="precio.estatus" class="status-pill" data-title="Activo" data-toggle="tooltip"
                                data-original-title title style="background-color: #4e9322;"></div>
                              <div v-if="!precio.estatus" class="status-pill red" data-title="Activo"
                                data-toggle="tooltip" data-original-title title></div>
                            </td>
                            <td class="text-right">
                              <a data-target="#modal-historial" data-toggle="modal" href="#"
                                @click="verHistorialDePrecio(precio)" class="btn btn-sm btn-primary">
                                <span>Detalle</span>&nbsp;
                                <i class="fas fa-eye"></i>
                              </a>
                            </td>
                          </tr>
                          <!-- FIN DETALLE POR UNIDAD DE MEDIDA ACTIVOS -->

                          <!-- INICIO DETALLE POR UNIDAD DE MEDIDA INACTIVOS -->
                          <tr v-for="precio in getListaPrecio(l_precio, false)" :key="precio.id"
                            id="preciosInactivosTable" v-show="switchState == 1">
                            <td class="nowrap">
                              {{ precio.unidad_medida.nombre }}
                            </td>
                            <td class="text-right">
                              {{ precio.valido_desde }}
                            </td>
                            <td class="text-right">
                              {{ precio.valido_hasta }}
                            </td>
                            <td class="text-right">{{ precio.costo }}</td>
                            <td class="text-right">
                              {{ precio.otros_costos }}
                            </td>
                            <td class="text-center">
                              {{ precio.tipo_calculo }}
                            </td>
                            <td class="text-center">
                              <span v-if="precio.tipo_calculo == 'FIJO'">Q</span>
                              {{ precio.margen }}
                              <span v-if="precio.tipo_calculo == 'PORC'">%</span>
                            </td>
                            <td class="text-right">{{ precio.precio }}</td>
                            <td class="text-right">
                              <div v-if="precio.estatus" class="status-pill green" data-title="Activo"
                                data-toggle="tooltip" data-original-title title></div>
                              <div v-if="!precio.estatus" class="status-pill red" data-title="Activo"
                                data-toggle="tooltip" data-original-title title></div>
                            </td>
                            <td class="text-right">
                              <a data-target="#modal-historial" data-toggle="modal" href="#"
                                @click="verHistorialDePrecio(precio)" class="btn btn-sm btn-primary">
                                <span>Detalle</span>&nbsp;
                                <i class="fas fa-eye"></i>
                              </a>
                            </td>
                          </tr>
                          <!-- FIN DETALLE POR UNIDAD DE MEDIDA INACTIVOS --> 
                        </tbody>
                      </table>
                      <!-- FIN TABLA DE LISTA DE PRECIOS -->
                    </div>
                  </div>  
                </div>
                <!--END - Tasks List-->
                
              </div>
          
              <div v-if="agregar">
                <AgregarPrecioModalComponent v-if="current.sku != null && lista_precio_actual != null"
                  :lista_precio="lista_precio_actual" :producto="current" @cerrandomodal="refreshProducto" />
              </div>
            </div> 
          </div>
        </div>
      </div>
    </div>
    <!--Modal - Edit Task-->
    <div aria-hidden="true" class="modal fade" id="modal-historial" role="dialog" tabindex="-1">
      <div class="modal-dialog modal-lg" role="document" v-if="precio_actual != null">
        <div class="modal-content" style="width: 100%; max-width: 100%">
          <div class="modal-header faded smaller">
            <div class="modal-title">
              <h5 style="color: #9aa2a6;">Detalle de Producto y UM</h5>
            </div>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="modal-title">
              <div class="row">
                <div class="col-8">
                  <h6><strong>SKU: {{ current.sku }}</strong></h6>
                  <h6><strong>{{ current.nombre }}</strong></h6>
                  <br>
                </div>
                <div class="col-4">
                  <span>Lista:</span>&nbsp;
                  <strong>{{ precio_actual.lista_precio.nombre }}</strong>
                  <br>
                  <span>Unidad Medida:</span>&nbsp;
                  <strong>{{ precio_actual.unidad_medida.nombre }}</strong>
                </div>
              </div>
            </div>
            <br />
            <table class="table table-bordered">
              <thead class="table-active">
                <tr>
                  <th>Rangos de Fechas</th>
                  <th class="text-right">Cálculo</th>
                  <th class="text-right">Margen</th>
                  <th class="text-right">Costo</th>
                  <th class="text-right">P. Venta</th>
                  <th class="text-center">Último Cambio</th>
                  <th class="text-center">Modificó</th>
                  <th class="text-center">Estado</th>
                  <th class="text-center"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="_hist in historial">
                  <td>
                    <span>{{ _hist.valido_desde }}</span>
                    <i class="os-icon os-icon-repeat icon-separator"></i>
                    <span>{{ _hist.valido_hasta }}</span>
                  </td>
                  <td class="text-right text-bright">
                    {{ _hist.tipo_calculo }}
                  </td>
                  <td class="text-right text-bright">
                    <span v-if="_hist.tipo_calculo == 'FIJO'">Q</span>
                    {{ _hist.margen }}
                    <span v-if="_hist.tipo_calculo == 'PORC'">%</span>
                  </td>
                  <td class="text-right text-bright">Q {{ _hist.costo }}</td>
                  <td class="text-right" :class="{ 'text-success': _hist.precio > _hist.costo }">
                    Q {{ _hist.precio }}
                  </td>
                  <td class="text-right">
                    {{ _hist.fecha_modificacion }}
                  </td>
                  <td class="text-right">
                    <UsuarioEnTablaComponent v-if="_hist.usuario_modificacion" :current="_hist.usuario_modificacion" />
                  </td>
                  <td class="text-center">
                    <div v-if="_hist.estatus" class="status-pill green" data-title="Activo" data-toggle="tooltip"
                      data-original-title title></div>
                    <div v-if="!_hist.estatus" class="status-pill red" data-title="Activo" data-toggle="tooltip"
                      data-original-title title></div>
                  </td>
                  <td>
                    <button v-if="_hist.estatus" @click="cambiarEstatus(_hist)" type="button"
                      class="btn btn-sm btn-danger">
                      <i class="os-icon os-icon-repeat icon-separator"></i>
                    </button>
                    <button v-if="!_hist.estatus" @click="cambiarEstatus(_hist)" type="button"
                      class="btn btn-sm btn-success">
                      <i class="os-icon os-icon-repeat icon-separator"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!---          <div class="modal-footer buttons-on-left">
            <button class="btn btn-link" data-dismiss="modal" type="button">
              Cerrar
            </button>
          </div>
          -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import ProductosService from "@/services/catalogos/ProductosService";
import ListaPreciosService from "@/services/catalogos/ListaPreciosService";
import ProductosTiendaService from "@/services/catalogos/ProductosTiendaService";
import Notifications from "@/notifications/notifications";
import AgregarPrecioModalComponent from "@/components/cat/productos/AgregarPrecioModalComponent";
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";
import DynamicService from "@/services/commons/DynamicService";

export default {
  components: {
    AgregarPrecioModalComponent,
    UsuarioEnTablaComponent,
  },
  data() {
    return {
      editando: false,
      sku: null,
      agregar: false,
      listas_de_precios: [],
      lista_precio_actual: null,
      current: {
        pk: null,
        errors: {},
        precios: [],
      },
      historial: [],
      precio_actual: null,
      switchState: 0,
      sectionStates: {},
      campanasEncontradas: [],
      campanasVigentes: [],
    };
  },
  props: ["sku_p"],
  computed: {},
  mounted() {
    let self = this;
    self.refreshListasDePrecios();
    if (self.$route.params.sku) {
      self.sku = self.$route.params.sku;
    }
    if (self.sku_p) {
      self.sku = self.sku_p;
    }
    self.refreshProducto();
    this.refreshUm();
    self.buscarCampanas();
  },
  methods: {
    refreshUm() {
      let self = this;
      let p = {
        activa: true,
        quitar_paginacion: true,
      };
      if (self.sku) {
        p.producto = self.sku;
      }
      this.$store.dispatch("catalogos/unidades_medidas", p);
    },
    getListaPrecio(lp, activos) {
      let self = this;
      var d = [];
      if (!self.current.productounidadmedida_set) {
        return d;
      }
      self.current.productounidadmedida_set.forEach(function (um) {
        var agregado = false;

        self.current.lista_precios.forEach(function (item, index) {
          if (
            item.unidad_medida.id == um.unidad_medida.id &&
            item.lista_precio.id == lp.id
          ) {
            if (activos) {
              d.push(item);
            }
            agregado = true;
          }
        });

        if (activos == false) {
          if (!agregado) {
            d.push({
              lista_precio: lp,
              unidad_medida: um.unidad_medida,
              costo: "-",
              valido_desde: null,
              valido_hasta: null,
              tipo_calculo: "",
              margen: "0.00",
              precio: "0.00",
              estatus: false,
              producto: self.producto,
            });
          }
        }
      });
      return d;
    },
    refreshProducto() {
      let self = this;
      self.agregar = false;
      ProductosService.getById(self.sku).then((response) => {
        self.current = response.data;
        self.current.errors = [];
        self.current.pk = self.current.sku;        
      });
    },
    refreshListasDePrecios() {
      let self = this;
      ListaPreciosService.fetch({
        quitar_paginacion: true,
      }).then((response) => {
        self.listas_de_precios = response.data;
      });
    },
    toggleSection(event, l_precio) {
      this.$set(this.sectionStates, l_precio.id, !this.sectionStates[l_precio.id]);
      $(event.target)
        .closest(".tasks-section")
        .find(".tasks-list-w")
        .slideToggle(100);
    },
    toggleSection2(event, key) {
      this.$set(this.sectionStates, key, !this.sectionStates[key]);
      $(event.target)
        .closest(".tasks-section")
        .find(".tasks-list-w")
        .slideToggle(100);
    },
    isSectionExpanded(l_precio) {
      return !!this.sectionStates[l_precio.id];
    },
    isSectionExpanded2(key){
      return !!this.sectionStates[key];
    },
    refreshHistorial() {
      let self = this;
      ProductosService.precios({
        producto: self.current.sku,
        lista_precio: self.precio_actual.lista_precio.id,
        unidad_medida: self.precio_actual.unidad_medida.id,
        quitar_paginacion: true,
        historial: true,
      }).then((response) => {
        self.historial = response.data;
      });
    },
    verHistorialDePrecio(precio) {
      let self = this;
      self.precio_actual = precio;
      self.refreshHistorial();
      $("#modal-historial").show();
    },
    cambiarEstatus(c) {
      let self = this;
      ProductosService.cambiar_estatus_a_precio(c.id).then((response) => {
        self.refreshHistorial();
        self.refreshProducto();
      });
    },
    showModal(l_precio) {
      let self = this;
      self.refreshUm();
      self.lista_precio_actual = l_precio;
      self.agregar = true;
    },
    showInactiveItems() {
      let self = this;
      return this.switchState == 1;
    },
    redondearDosDecimales(valor) {
      if (!valor) return 0;
      return Math.round(valor * 100) / 100;
    },
    buscarCampanas() {
      //Busca si el producto está en alguna campaña activa, y si está, obtiene 
      //el listado de los precios en cada campaña
      let self = this;        
      let id=''
      let params = { sku: self.sku}

      DynamicService.getActionList(
        "cat",
        "oferta-producto",        
        "verificar_productos_en_otras_ofertas",
        params
        ).then((response)=>{        
          self.campanasEncontradas=response.data 
          self.campanasActuales();       
      })
    },
    campanasActuales(){
      let self= this;
      //obtener fecha actual
      const hoy = new Date();
      let fechaHoy = hoy.toISOString().split('T')[0];   

      self.campanasEncontradas.forEach(ca => {
        const partes= ca.fecha_fin.split('/');
        const fechaFin = new Date(`${partes[2]}-${partes[1]}-${partes[0]}`);
        const fechaHoyDate = new Date(fechaHoy);

        if(fechaHoyDate <= fechaFin){          
          self.campanasVigentes.push(ca)
        }        
      })
    },
  },
};
</script>
